import { render, staticRenderFns } from "./ucusara.vue?vue&type=template&id=5f4e3050&scoped=true"
import script from "./ucusara.vue?vue&type=script&lang=js"
export * from "./ucusara.vue?vue&type=script&lang=js"
import style0 from "./ucusara.vue?vue&type=style&index=0&id=5f4e3050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4e3050",
  null
  
)

export default component.exports